import React from 'react'
import styled, { css } from 'styled-components'

const StyledBadge = styled.span`
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;

    ${(props) =>
        props.variant === 'primary' &&
        css`
            color: #fff;
            background-color: #007bff;
        `}

    ${(props) =>
        props.variant === 'secondary' &&
        css`
            color: #fff;
            background-color: #6c757d;
        `}

  ${(props) =>
        props.variant === 'success' &&
        css`
            color: #fff;
            background-color: #28a745;
        `}

  ${(props) =>
        props.variant === 'danger' &&
        css`
            color: #fff;
            background-color: #dc3545;
        `}

  ${(props) =>
        props.variant === 'warning' &&
        css`
            color: #212529;
            background-color: #ffc107;
        `}

  ${(props) =>
        props.variant === 'info' &&
        css`
            color: #fff;
            background-color: #17a2b8;
        `}

  ${(props) =>
        props.pill &&
        css`
            padding-right: 0.6em;
            padding-left: 0.6em;
            border-radius: 10rem;
        `}
`

const Badge = ({ children, variant = 'primary', pill = false, ...props }) => {
    return (
        <StyledBadge variant={variant} pill={pill} {...props}>
            {children}
        </StyledBadge>
    )
}

export default Badge
